import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { notification } from 'antd';
import Header from '../Inc/Layout/Header.js';
import Footer from '../Inc/Layout/Footer.js';
import { sendContactUsAction } from '../../actions/ContactUs.js';
import { SignUpSubUserAction } from '../../actions/SignUp.js';
import CustomLinkedIN from '../Linkdin/CustomLinkedIN.js'
import '../../index.css';

class SubUserSignUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            header: "",
            formData: {},
            userData: false,
            captcha: false
        };
        this.submitFrom=this.submitFrom.bind(this);
    }

    componentDidMount() {
		console.log("sub-user-verify", this.props);
    }    
    submitFrom() {
		this.props.SignUpSubUserAction(this.state.formData)
    }

    shouldComponentUpdate(nextProps, nextState){
    	const {location} = this.props;
    	if(location && location.state && location.state.userInfo && location.state.userInfo.userData && !this.state.userData){
	        	console.log("location.state.userInfo.userData", location.state.userInfo);
	        let reqObj = {
	        	"id":location.state.userInfo.userData._id,
	            "firstName": location.state.userInfo.userData.firstName,
	            "companyName":location.state.userInfo.companyData.firstName,
	            "subUserCompanyId":location.state.userInfo.companyData._id,
	            "email": location.state.userInfo.userData.email,
	            "linkedInId": location.state.userInfo.id
			};
    		this.setState({
    			formData:reqObj,
    			userData:true
    		})
    	}
    	return true;
    }
    componentWillReceiveProps(nextProps) {
    	        if (nextProps && nextProps.signup && nextProps.signup.response.statusCode === 200) {
            //className=
            var redirectPage = "";
            const userInfo = nextProps.signup.response.userData;
            // console.log("userInfo", userInfo); 
            if (userInfo) {
                localStorage.setItem('userData', JSON.stringify(userInfo))
                localStorage.setItem('JWTTOKEN', userInfo.token)
                localStorage.setItem('userLogin', true)
                if (userInfo && userInfo.userType === "user") {
                    redirectPage = this.props.auth.cityUrlFunction("/home");
                } else {
                    redirectPage = "/dashboard-home"
                }
                this.props.history.push({
                    pathname: redirectPage,
                    state: { "userInfo": userInfo }
                });
                notification.success({
                    message: "Signed in successfully",
                    className:'successNotification',
                    duration: 3
                });

            }

        } else if (nextProps && nextProps.signup && nextProps.signup.response.statusCode === 500) {
            notification.error({
                message: nextProps.signup.message,
                className:'errorNotification',
                duration: 3
            });
        }
    }


    render() {

			console.log("render----");
        const { formData, userData } = this.state
        return (
				<div className="home-wrapper">
					<Header noLeftBar={true} />
					<div className="body-wrapper contactwallpapers">
						<div className="container">
							<div className="row">
							{!userData && 
								<div className="col-lg-8 col-md-12 contact-box">
									<div className="row">
										<div className="col-lg-7 col-md-6 ">
											<h6>Your Registered Email Use In LinkdIn Sign In</h6>
										</div>
										<div className="col-lg-7 col-md-6 sign-button">
											<CustomLinkedIN textTtile={"Please Verify With Linkdin"} props={ this.props } useFor={"verify"} />
										</div>
									</div>
								</div>
							}							
							{userData && 
								<div className="col-lg-8 col-md-12 contact-box">
									<div className="row">
	                                   	<div className="bg-signup">
	                                        <div className="signIn-section">
	                                            <div className="form-group">
	                                                <label>Name<span>*</span></label> 
	                                                <input type="text" className="form-control singup-control" name="name" disabled readOnly placeholder="" value={formData.firstName} />
	                                            </div>
	                                            <div className="form-group">
	                                                <label>Email<span>*</span></label>
	                                                <input type="text" className="form-control singup-control" name="email" disabled readOnly placeholder="" value={formData.email} />
	                                            </div>
	                                            <div className="form-group">
	                                                <label>Company</label>
	                                                <input type="text" className="form-control singup-control" name="companyName" disabled readOnly placeholder="" value={formData.companyName} />
	                                            </div>
	                                       
	                                            <div className="form-group">
	                                                <button type="button" className="btn submit-btn" onClick={this.submitFrom}>Verify</button>
	                                            </div>
	                                        </div>
	                                    </div>
									</div>
								</div>
							}	
							</div>
						</div>
					</div>
					<Footer/>
				</div>
        )
    }
}


       


function mapStateToProps(state) {
    console.log("state", state);
    return {
        contactUsResponse: state.ContactUs.response,
         signup: state.SignUp
    }
}

export default withLocalize(withRouter(connect(mapStateToProps, {
    sendContactUsAction,
    SignUpSubUserAction
})(SubUserSignUp)));


// WEBPACK FOOTER //
// ./src/components/SignUp/SubUserSignUp.js